export const STEPPER_HEIGHT = 65;
